import React from 'react';
import { CButton, CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle } from '@coreui/react-pro';
import PropTypes from 'prop-types';
import { DEFAULT_FN } from '../../../constants';
import { Waiting } from '../Loadings';
import { useDispatch } from 'react-redux';
import { setShow } from '../../../actions/general';
import CIcon from '@coreui/icons-react';

const PopupRemoveSeat = ({ title, loading, onCancel, onRemove }) => {
     const dispatch = useDispatch();

     return (
          <>
               <CModal visible={true} className="popup-send-invoice remove-cancelled">
                    <CModalHeader closeButton={false}>
                         <CModalTitle>Confirm Remove Seats</CModalTitle>
                         <CIcon icon="cil-x" height={25} alt="CoreUI Icons Delete" onClick={() => dispatch(setShow(null))} />
                    </CModalHeader>
                    <CModalBody>
                         <p className="m-0 text-center">{title}</p>
                    </CModalBody>
                    <CModalFooter>
                         <CButton disabled={loading} className="me-3" onClick={onRemove}>
                              <Waiting isLoading={loading}>Yes</Waiting>
                         </CButton>
                         <CButton disabled={loading} color="secondary" onClick={onCancel}>
                              No
                         </CButton>
                    </CModalFooter>
               </CModal>
          </>
     );
};

PopupRemoveSeat.propTypes = {
     title: PropTypes.string,
     loading: PropTypes.bool,
     onClose: PropTypes.func,
     onCancel: PropTypes.func,
     onRemove: PropTypes.func,
};

PopupRemoveSeat.defaultProps = {
     title: '',
     loading: false,
     onClose: DEFAULT_FN,
     onCancel: DEFAULT_FN,
     onRemove: DEFAULT_FN,
};

export default PopupRemoveSeat;
